import { motion } from 'motion/react'
import BlockTitle from 'src/components/BlockTitle'
import Icon from 'src/components/Icon'
import Link from 'src/components/Link'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Links = styled(motion.ul)<{ $mobile?: boolean }>`
  ${({ theme }) => theme.textStyles.d1440_body}
  gap: ${pxToRem(10)};
  margin-inline: auto;

  width: 100%;
  list-style: none;

  ${({ $mobile }) =>
    $mobile &&
    `
      display: flex;
      flex-flow: column;
      max-width: calc(100% - ${pxToRem(16)} * 2);
      @media ${mq(sizes.desktop)} {
        display: none;
      }
    `}
  ${({ $mobile }) =>
    !$mobile &&
    `
      display: grid;
      grid-template-columns: 1fr 1fr;
      max-width: calc(100% - ${pxToRem(32)} * 2);
      @media ${mq(null, sizes.desktop)} {
        display: none;
      }
      @media ${mq(sizes.big)} {
        grid-template-columns: 1fr 1fr 1fr;
      }
    `}
`
export const _Link = styled(Link)<{ $color?: string }>`
  ${({ theme }) => theme.textStyles.m375_h3}
  --background-color--hover: ${({ theme, $color }) =>
    $color ? $color : theme.colors.blueLight};
  --color--hover: ${({ theme, $color }) =>
    $color === theme.colors.black ? theme.colors.white : theme.colors.black};
  display: flex;
  gap: ${pxToRem(24)};
  align-items: center;
  justify-content: space-between;
  padding-inline: ${pxToRem(24)};
  padding-block: ${pxToRem(24)};
  width: 100%;
  height: 100%;
  min-height: ${pxToRem(80)};
  border: 1px solid rgba(0, 0, 0, 0.5);
  line-height: 1.2;
  text-wrap: balance;
  color: ${({ theme }) => theme.colors.black};
  transition:
    color 0.3s,
    background-color 0.3s;
  &:active,
  &:hover,
  &:focus {
    color: var(--color--hover);
    background-color: var(--background-color--hover);
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2};
    min-height: ${pxToRem(172)};
    padding-inline: ${pxToRem(40)};
    line-height: 1.2;
  }
`
export const Label = styled.span``
export const Arrow = styled(Icon)`
  width: ${pxToRem(32)};
  flex: 0 0 auto;
  display: flex;
  aspect-ratio: 1;
  transition: transform 0.3s ease-in-out;
  ${_Link}:hover &,
  ${_Link}:focus & {
    transform: translateX(${pxToRem(8)});
  }
  @media ${mq(sizes.desktop)} {
    width: ${pxToRem(48)};
  }
`
